import React from "react";
import { Tabs, Radio, Button } from "antd/lib";
const { TabPane } = Tabs;

interface SamplePageProps {}

type SamplePageState = {
  mode: string;
};

class SamplePage extends React.Component<SamplePageProps, SamplePageState> {
  constructor(props: any) {
    super(props);
    this.state = {
      mode: "top",
    };
  }

  handleModeChange = (e: any) => {
    const mode = e.target.value;
    this.setState({ mode });
  };

  render() {
    const { mode } = this.state;
    return (
      <div>
        <Button danger={true} shape="circle">
          +
        </Button>
        <Radio.Group
          onChange={this.handleModeChange}
          value={mode}
          style={{ marginBottom: 8 }}
        >
          <Radio.Button value="top">Horizontal</Radio.Button>
          <Radio.Button value="left">Vertical</Radio.Button>
        </Radio.Group>
        <Tabs
          // onTouchMove={(e) => console.log("e", e.target)}
          defaultActiveKey="1"
          tabPosition={mode as any}
          style={{ height: 220 }}
        >
          {[...Array.from({ length: 30 }, (v, i) => i)].map((i) => (
            <TabPane tab={`Tab-${i}`} key={i as any} disabled={i === 28}>
              Content of tab {i}
            </TabPane>
          ))}
        </Tabs>
      </div>
    );
  }
}

export default SamplePage;
